import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import { FaCheck } from "react-icons/fa";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import useApi from "../../hooks/useApi";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { number, string } from "yup";

export const VehicleOwnersAddVehicle = () => {
  const location = useLocation();
  const { item } = location?.state || {};

  // console.log(item,"ioioioioioi");
  let initialState = {
    license_plate: "",
    fuel_type: "",
    insurance_provider: "",
    policy_number: "",
    vehicle_year: "",
    vehicle_brand: "",
    vehicle_model: "",
    vehicle_length: 0,
    gig_or_ride_share: "",
    commercial: "",
    vehicle_type: "",
    frontside_image: null,
    rearside_image: null,
    driverside_image: null,
    passengerside_image: null,
  };

  const [vehicle, setVehicle] = useState(initialState);

  const [select, setSelect] = useState();
  const [vehicleType, setVehicleType] = useState([]);
  const [type, setType] = useState();
  const [loading, setLoading] = useState(false);
  const handleChange = (key, value) => {
    if (key === "vehicle_type") {
      console.log(key,"key",value,"value");
      setVehicle({ ...vehicle, [key]: value, vehicle_length: 0 });
    } else {
      setVehicle({ ...vehicle, [key]: value });
    }
  };

  console.log(vehicle, "vehicle");
  const navigate = useNavigate();
  const handleImageChange = (key, e) => {
    const imageFile = e.target.files[0];
    handleChange(key, imageFile);
    const previewUrl = URL.createObjectURL(imageFile);
    console.log(previewUrl, "previewUrl");

    setVehicle({ ...vehicle, [key]: { file: imageFile, previewUrl } });
  };

  const fetchVehicleTypes = async () => {
    const res = await apiClient.get("/vehicles/vehicle-types/");
    if (res.ok) {
      setVehicleType(res.data);
    }
  };
  useEffect(() => {
    fetchVehicleTypes();
    if (item) {
      setType(item.vehicle_type);
      console.log(item.id, "item.vehicle_type");
      setVehicle(item);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !vehicle.frontside_image ||
      !vehicle.rearside_image ||
      !vehicle.driverside_image ||
      !vehicle.passengerside_image ||
      !type
    ) {
      toast.error("Please fill in all required fields");
      return;
    }
  
    const formData = new FormData();

    if (vehicle.frontside_image && vehicle.frontside_image.file) {
      formData.append("frontside_image", vehicle.frontside_image.file);
    }

    if (vehicle.rearside_image && vehicle.rearside_image.file) {
      formData.append("rearside_image", vehicle.rearside_image.file);
    }

    if (vehicle.driverside_image && vehicle.driverside_image.file) {
      formData.append("driverside_image", vehicle.driverside_image.file);
    }

    if (vehicle.passengerside_image && vehicle.passengerside_image.file) {
      formData.append("passengerside_image", vehicle.passengerside_image.file);
    }

    formData.append("license_plate", vehicle.license_plate);
    formData.append("fuel_type", vehicle.fuel_type);
    formData.append("insurance_provider", vehicle.insurance_provider);
    formData.append("policy_number", vehicle.policy_number);
    formData.append("vehicle_year", vehicle.vehicle_year);
    formData.append("vehicle_brand", vehicle.vehicle_brand);
    formData.append("vehicle_model", vehicle.vehicle_model);
    formData.append("vehicle_length", vehicle.vehicle_length);
    formData.append("gig_or_ride_share", vehicle.gig_or_ride_share);
    formData.append("commercial", vehicle.commercial);
    if(  vehicle.vehicle_type ){

      formData.append("vehicle_type",  vehicle.vehicle_type.toLocaleLowerCase);
    }

    let result;
    try {
      if (item) {
        setLoading(true);
        result = await apiClient.patch(
          `/vehicles/vehicles/${item.id}/`,
          formData
        );
        setLoading(false);
        if (!result.ok) throw new Error("Error");
        {
          toast.success("Vehicle Update Successfully");
          navigate("/vehicleownervehicle");
        }
      } else {
        setLoading(true);
        result = await apiClient.post(`/vehicles/vehicles/`, formData);
        setLoading(false);
        {
          navigate("/vehicleownervehicle");
        }
      }

    } catch (error) {
      toast.error("Error uploading vehicle");
    } 
  };
  const semiTruck = [26, 28, 48, 53];
  const boxTruck = [14, 16, 18, 22, 24, 26, 28];
  const bus = [23, 35, 40, 42];
  const vehicleLength = (item) => {
    return item.name === "Semi Truck"
      ? semiTruck.map((ele) => {
          return (
            <div class="mt-2 form-check ">
              <input
                class="form-check-input"
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault1"
                value={ele}
                onClick={(e) => handleChange("vehicle_length", e.target.value)}
              />
              <label class=" form-check-label" for="flexRadioDefault1">
                {`${ele}ft`}
              </label>
            </div>
          );
        })
      : item.name === "Box Truck"
      ? boxTruck.map((ele) => {
          return (
            <div class="mt-2 form-check">
              <input
                class="form-check-input"
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault1"
                value={ele}
                onClick={(e) => handleChange("vehicle_length", e.target.value)}
              />
              <label class="form-check-label" for="flexRadioDefault1">
                {`${ele}ft`}
              </label>
            </div>
          );
        })
      : item.name === "Bus"
      ? bus.map((ele) => {
          return (
            <div class="mt-2 form-check">
              <input
                class="form-check-input"
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault1"
                value={ele}
                onClick={(e) => handleChange("vehicle_length", e.target.value)}
              />
              <label class="form-check-label" for="flexRadioDefault1">
                {`${ele}ft`}
              </label>
            </div>
          );
        })
      : "";
  };

  console.log(vehicle, "vehiclevehiclevehiclevehicle");
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="site-content h-100">
          <div className="p-4">
            <div className="site-content-body">
              <div className="add-vehicles-images row">
                <div className="col-lg-3 col-md-6">
                  <div className="add-vehicle-image d-flex flex-column align-items-center justify-content-center">
                    <label
                      htmlFor="front-side"
                      className="blue-clr fs-5 lh-base"
                    >
                      Front Side
                    </label>
                    {vehicle.frontside_image ? (
                      <label htmlFor="front-side">
                        <div className="label-box d-flex justify-content-center align-items-center">
                          <img
                            width={"100%"}
                            height={"100%"}
                            style={{ borderRadius: "12px" }}
                            src={
                              vehicle.frontside_image.previewUrl ||
                              item.frontside_image ||
                              ""
                            }
                            alt=""
                          />
                        </div>
                      </label>
                    ) : (
                      <label
                        htmlFor="front-side"
                        className="label-box d-flex justify-content-center align-items-center"
                      >
                        <i className="bi bi-image" />
                      </label>
                    )}
                    <input
                      type="file"
                      className="d-none"
                      id="front-side"
                      onChange={(e) => handleImageChange("frontside_image", e)}
                    />
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div className="add-vehicle-image d-flex flex-column align-items-center justify-content-center">
                    <label
                      htmlFor="rear-side"
                      className="blue-clr fs-5 lh-base"
                    >
                      Rear Side
                    </label>
                    {vehicle.rearside_image ? (
                      <label htmlFor="rear-side">
                        <div className="label-box d-flex justify-content-center align-items-center">
                          <img
                            width={"100%"}
                            height={"100%"}
                            style={{ borderRadius: "12px" }}
                            src={
                              vehicle.rearside_image.previewUrl ||
                              item.rearside_image ||
                              ""
                            }
                            alt=""
                          />
                        </div>
                      </label>
                    ) : (
                      <label
                        htmlFor="rear-side"
                        className="label-box d-flex justify-content-center align-items-center"
                      >
                        <i className="bi bi-image" />
                      </label>
                    )}
                    <input
                      type="file"
                      className="d-none"
                      id="rear-side"
                      onChange={(e) => handleImageChange("rearside_image", e)}
                    />
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div className="add-vehicle-image d-flex flex-column align-items-center justify-content-center">
                    <label
                      htmlFor="driver-side"
                      className="blue-clr fs-5 lh-base"
                    >
                      Driver Side
                    </label>
                    {vehicle.driverside_image ? (
                      <label htmlFor="driver-side">
                        <div className="label-box d-flex justify-content-center align-items-center">
                          <img
                            width={"100%"}
                            height={"100%"}
                            style={{ borderRadius: "12px" }}
                            src={
                              vehicle.driverside_image.previewUrl ||
                              item.driverside_image ||
                              ""
                            }
                            alt=""
                          />
                        </div>
                      </label>
                    ) : (
                      <label
                        htmlFor="driver-side"
                        className="label-box d-flex justify-content-center align-items-center"
                      >
                        <i className="bi bi-image" />
                      </label>
                    )}
                    <input
                      type="file"
                      className="d-none"
                      id="driver-side"
                      onChange={(e) => handleImageChange("driverside_image", e)}
                    />
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div className="add-vehicle-image d-flex flex-column align-items-center justify-content-center">
                    <label
                      htmlFor="passenger-side"
                      className="blue-clr fs-5 lh-base"
                    >
                      Passenger Side
                    </label>
                    {vehicle.passengerside_image ? (
                      <label htmlFor="passenger-side">
                        <div className="label-box d-flex justify-content-center align-items-center">
                          <img
                            width={"100%"}
                            height={"100%"}
                            style={{ borderRadius: "12px" }}
                            src={
                              vehicle.passengerside_image.previewUrl ||
                              item.passengerside_image ||
                              ""
                            }
                            alt=""
                          />
                        </div>
                      </label>
                    ) : (
                      <label
                        htmlFor="passenger-side"
                        className="label-box d-flex justify-content-center align-items-center"
                      >
                        <i className="bi bi-image" />
                      </label>
                    )}
                    <input
                      type="file"
                      className="d-none"
                      id="passenger-side"
                      onChange={(e) =>
                        handleImageChange("passengerside_image", e)
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="input-fields row mt-2">
                <div className="col-md-6 ">
                  <div className="input-field d-flex flex-column mb-3 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="liscence-plate"
                    >
                      Liscence Plate #
                    </label>
                    <input
                      required
                      type="text"
                      value={vehicle?.license_plate}
                      onChange={(e) =>
                        handleChange("license_plate", e.target.value)
                      }
                      className="form-control m-1 w-75 px-2 py-1 fs-4"
                      id="liscence-plate"
                      // placeholder="678YLJ"
                    />
                  </div>

                  <div className="input-field d-flex flex-column mb-3 fs-5">
                    <label className="label blue-clr m-1" htmlFor="fuel-type">
                      Fuel Type
                    </label>
                    <select
                      class="form-select w-75 px-2 fs-4 py-1"
                      aria-label="Default select example"
                      onChange={(e) =>
                        handleChange("fuel_type", e.target.value)
                      }
                    >
                      <option selected value={vehicle?.fuel_type}>
                        {vehicle.fuel_type || "Select Fuel Type"}
                      </option>
                      <option value="gasoline">Gasoline</option>
                      <option value="diesel">Diesel</option>
                      <option value="electric">Electric</option>
                      <option value="hybrid">Hybrid</option>
                    </select>
                  </div>
                  <div className="input-field d-flex flex-column mb-3 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="insurance-provider"
                    >
                      Insurance Provider
                    </label>
                    <input
                      required
                      type="text"
                      value={vehicle?.insurance_provider}
                      onChange={(e) =>
                        handleChange("insurance_provider", e.target.value)
                      }
                      className="form-control m-1 w-75 px-2 py-1 fs-4"
                      id="insurance-provider"
                      // placeholder="Nationwide"
                    />
                  </div>
                  <div className="input-field d-flex flex-column mb-3 fs-5">
                    <label
                      className="label blue-clr m-1"
                      htmlFor="policy-number"
                    >
                      Policy Number
                    </label>
                    <input
                      required
                      type="text" // Change type to text
                      value={vehicle?.policy_number}
                      onChange={(e) =>
                        handleChange("policy_number", e.target.value)
                      }
                      className="form-control m-1 w-75 px-2 py-1 fs-4"
                      id="policy-number"
                      // placeholder="123-456-789"
                    />
                  </div>
                </div>
                <div className=" col-md-6">
                  <div className="vehicle-right-input">
                    <div className=" d-flex align-items-center mb-3 ps-2">
                      <div className="d-flex flex-column me-2 input-field">
                        <label htmlFor="year" className="blue-clr fs-4">
                          Year
                        </label>
                        <input
                          required
                          type="number"
                          value={vehicle?.vehicle_year}
                          onChange={(e) =>
                            handleChange("vehicle_year", e.target.value)
                          }
                          // placeholder={2012}
                          id="year"
                          className="form-control px-2 py-1 fs-4"
                        />
                      </div>

                      <div className="d-flex flex-column me-2 input-field">
                        <label htmlFor="make" className="blue-clr fs-4">
                          Make
                        </label>
                        <input
                          required
                          type="text"
                          value={vehicle?.vehicle_brand}
                          onChange={(e) =>
                            handleChange("vehicle_brand", e.target.value)
                          }
                          // placeholder="Isuzu"
                          id="make"
                          className="form-control px-2 py-1 fs-4"
                        />
                      </div>

                      <div className="d-flex flex-column me-2 input-field">
                        <label htmlFor="model" className="blue-clr fs-4">
                          Model
                        </label>
                        <input
                          required
                          type="text"
                          value={vehicle?.vehicle_model}
                          onChange={(e) =>
                            handleChange("vehicle_model", e.target.value)
                          }
                          // placeholder="N-series"
                          id="model"
                          className="form-control px-2 py-1 fs-4"
                        />
                      </div>
                    </div>
                    <div className=" vehicle-type  ">
                      <label className="blue-clr fs-4 ps-2">Vehicle Type</label>
                      <div className="row">
      {vehicleType.map((item) => (
        <div key={item.id} className="col-4 ">
          <div className="dropdown">
            <button
              style={{
                borderRadius: "10px",
                backgroundColor: type === item?.name ? "#F3F3F3" : "",
                cursor: "pointer",
              }}
              className="dropdown-toggle py-2 px-3 vehicle-type-btn m-2"
              type="button"
              id={`vehicle${item.id}`}
              value={item.id}
              data-bs-toggle="dropdown"
              aria-expanded="false"
              title={item.name}
              onClick={(e) => {
                setType(item.name);
                handleChange("vehicle_type", item.id);
              }}
            >
              <img
                src={item.icon_url}
                alt=""
                className={`img-fluid ${
                  item.name === "Semi Truck" ? "w-75" : "w-50"
                }`}
              />
            </button>
            {["Semi Truck", "Box Truck", "Bus"].includes(item.name) ? (
              <ul
                className="dropdown-menu w-auto border border-secondary rounded-3 p-2"
                aria-labelledby={`vehicle${item.id}`}
              >
                <li className=" blue-clr text-decoration-underline">Length</li>
                {vehicleLength(item)}
              </ul>
            ) : (
              ""
            )}
          </div>
        </div>
      ))}
    </div>
                    </div>

                    <div className="d-flex align-items-center mb-3">
                      <div className="d-flex flex-column me-2 input-field">
                        <label htmlFor className="blue-clr fs-4 m-2">
                          Route Type
                        </label>

                        <div className="d-flex gap-3 align-items-center">
                          {/* <div
                            style={{
                              border: `2px solid `,
                              borderRadius: "20px",
                              borderColor: vehicle.select === "gig" ? "blue" : "initial",
                              cursor: "pointer",
                            }}
                            onClick={() => handleChange("select", "gig")}
                          >
                            <p
                              style={{ fontSize: "12px" }}
                              className="mb-0 fw-bold p-2"
                            >
                              Gig/Ride Share
                            </p>
                          </div> */}
                          <div>
                            <label className="blue-clr mb-2" htmlFor="">
                              Gig/Ride Share
                            </label>
                            <select
                              className="form-select"
                              value={
                                vehicle.vehicle_type === 2
                                  ? "true"
                                  : "false"
                              }
                              onChange={(e) =>
                                handleChange(
                                  "gig_or_ride_share",
                                  e.target.value
                                )
                              }
                              disabled={true} // Disable if vehicle type is not car
                            >
                          <option   value="true">Yes</option>

                              <option selected value="false">No</option>
                              
                            </select>
                          </div>

                          {/* <div
                            style={{
                              border: "2px solid",
                              borderRadius: "20px",
                              borderColor: vehicle.select === "cmc" ? "blue" : "initial",
                              cursor: "pointer",
                            }}
                            onClick={() => handleChange("select", "cmc")}
                          >
                            <p
                              style={{ fontSize: "12px" }}
                              className="mb-0 fw-bold p-2"
                            >
                              Commerical
                            </p>
                          </div> */}

                          <div>
                            <label className="blue-clr mb-2" htmlFor="">
                              Commercial
                            </label>
                            <select
                              className="form-select"
                              value={
                                vehicle.vehicle_type === 2
                                  ? "false"
                                  : "true"
                              }
                              onChange={(e) =>
                                handleChange("commercial", e.target.value)
                              }
                              disabled={true} // Disable if vehicle type is car
                            >
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
                <div className="row select-applies">
                  {loading ? (
                    <div className="text-center mt-3">
                      <h1>
                        {" "}
                        <CircularProgress />
                      </h1>
                    </div>
                  ) : (
                    <div className="  d-flex justify-content-center ">
                      <button
                        type="submit"
                        className="btn_bgnone save-changes blue-clr p-3 fs-4 border-0"
                      >
                        <span className="pe-2">Save Changes</span>
                        <FaCheck />
                      </button>
                    </div>
                  )}
                </div>
            </div>
          </div>
        </div>
        {/* Loading Indicator */}
      </form>
    </div>
  );
};
